<template lang="pug">
v-layout
  v-flex.sud-block-overlay.mr-1(xs6)
    .text-center.my-1
      v-btn(small icon @click="loadEventsForPrevPeriod")
        v-icon chevron_left
      .month.mx-2 {{ formattedPeriod }}
      v-btn(small icon @click="loadEventsForNextPeriod")
        v-icon chevron_right

    .grid
      .weekday.grid__item.text-center.py-1(v-for="(day, index) in weekdays" :key="day" :class="{ 'weekday--lighten': index >= 5 }") {{ day }}
      calendar-month-day.grid__item(v-for="date in periodDates" :key="date" :date="date" @click.native="selectItem(date)")

  v-flex.sud-block-overlay(xs6)
    .events-title События дня
      span.events-title__date.ml-4 {{ formattedDay }}
    .events-empty(v-if="!selectedDate || selectedDayEvents.length == 0") Нет событий на эту дату
    app-card(v-for="ev in selectedDayEvents" :key="ev.id" @click.native="selectEvent(ev)")
      app-card-header 
        .event-time {{ ev.eventDate | eventTime }}
        v-spacer
        span {{ ev.durability | duration }}
      app-card-body
        .event-name {{ ev.name }}
        app-card-caption {{ ev.notes }}
        //- .event-tags {{ ev.eventTags | tagsToString }}
        test
        .event-tags
          span(v-for="(e, index) in ev.eventTags" :key="index")
            span(:style="'border-bottom: 2px solid ' + e.color") {{ '#' + e.name }}
            //- span(:style="'color: ' + e.color") {{ '#' + e.name }}
            span.mr-2 {{ index < ev.eventTags.length - 1 ? ', ' : ''}}
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import CalendarMonthDay from "./CalendarMonthDay"
import moment from '@/common/AppMoment.js'

export default {
  components: {
    CalendarMonthDay
  },

  data () {
    return {
      weekdays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
    }
  },

  computed: {
    ...mapState('event', ['period', 'selectedDate']),
    ...mapGetters('event', ['filteredEvents', 'periodDates']),

    formattedPeriod () {
      return moment(this.period.date).format('MMMM YYYY')
    },

    formattedDay () {
      return this.selectedDate ? moment(this.selectedDate).format('DD MMMM') : 'Не выбрана дата'
    },

    selectedDayEvents () { 
      return this.filteredEvents.filter(ev => moment(ev.eventDate).isSame(this.selectedDate, 'day'))
    },
  },

  methods: {
    ...mapMutations('event', ['selectEvent', 'createEmptyEvent', 'selectDate', 'resetEvent']),
    ...mapActions('event', ['loadEventsForPrevPeriod', 'loadEventsForNextPeriod']),

    selectItem (day) {
      this.selectDate(day)
      if (this.selectedDayEvents.length == 0) {
        this.selectEvent({ eventDate: day })
      }
    }
  },

  filters: {
    tagsToString: (tags) => tags.map(t => `# ${t.name}`).sort().join(', '),
    eventTime: (date) => date.split(' ')[1],
    duration: (durability) => `Продолжительность: ${ moment.duration(durability, 'minutes').humanize() }`
  },
}
</script>

<style lang="scss" scoped>
.month {
  display: inline-block;
  font-family: Roboto Slab;
  text-transform: capitalize;
  font-size: large;
}

.grid {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.grid__item {
  $space: 2px;

  width: 14%;
  width: calc((100% - #{$space} * 7)/7);
  margin-bottom: $space;
  margin-right: $space;
}

.weekday {
  font: 18px Roboto Condensed;

  &--lighten {
    color: #C4C4C4;
  }
}

.events-title {
  margin: 8px 16px 12px 4px;
  font-family: Roboto Slab;
  
  &__date {
    color: #00BCD4;
  }
}

.events-empty {
  border: 1px solid gray;
  line-height: 48px;
  text-align: center;
  text-transform: uppercase;
}

.event-time {
  font-weight: bold;
  font-size: 18px;
}

.event-name {
  font: 16px/18px Roboto Slab;
  color: #314369;
}

.event-tags {
  margin-top: 20px;
  font: 16px Roboto Condensed;
  color: #959595;
}
</style>